import React from 'react';
import { Typography, Box } from '@material-ui/core';

const DisplayField = ({ label, value, color }) => {
  return (
    <Box display="flex" alignContent="flex-start" flexDirection="column" pb={1}>
      <Typography variant="caption" gutterBottom>
        {label}
      </Typography>
      <Typography variant="h6" color={color}>
        {value}
      </Typography>
    </Box>
  );
};

export default DisplayField;
